<palantir-sidemenu
  [menuItems]="menuItems()"
  [menuExpanded]="!isCollapsed()"
  [user]="sideMenuUser()"
  [company]="sideMenuCompany()"
  [notificationCount]="notificationCount()"
  [showRocketButton]="canShowBlogNotifications()"
  (menuItemClick)="onMenuItemClick($event)"
  (userActionClick)="onUserAction($event)"
  (helpButtonClick)="onHelpButtonClick()"
  (notificationButtonClick)="onNotificationButtonClick()"
  (rocketButtonClick)="onRocketButtonClick()"
/>
